'use client';
import Search from '@/client-side/search';
import { Suspense } from 'react';

const SearchPage = () => {
  return <Suspense>
    <Search />
  </Suspense>;
};

export default SearchPage;
